import { Inject, Injectable, Optional, PLATFORM_ID } from '@angular/core';
import { OtherBuckets } from '~shared/modules/catalog/constants/other-buckets.constants';
import { getCountryDomainCode } from '~server/utils/country-detection.util';
import { REQUEST } from '@nguniversal/express-engine/tokens';
import { OutOfScopeCategory } from '~app/modules/generic/models';
import { environment } from '~env/environment';
import { isPlatformBrowser } from '@angular/common';
import { MarketDetectionUtil } from '~shared/utils/market-detection.util';
import { getOtherBucketsUrl } from '~shared/modules/catalog/utils/other-buckets.utils';

@Injectable({
  providedIn: 'root',
})
export class OutOfScopeService {
  hasOutOfScopeTerms = false;
  userCountryOutOfScopeCategoryList: OutOfScopeCategory;
  // These lists are temporarily added for out of scope experiment //
  //Mock images to be replaced by original ones when received//
  outOfScopeCategoryList = {
    de: [
      {
        id: '1cc17afc-c78e-40f5-a0c8-b0e87b86b7ed',
        name: 'Lebensmittel',
        slug: 'lebensmittel',
        image: `${environment.cdnBaseUrl()}/images/zero-results-page/DE-market/lebensmittel.webp`,
      },
      {
        id: '6b9a85d7-c287-4d35-9186-cc7ceb8691b4',
        name: 'Gastro K\u00fchlschr\u00e4nke ',
        slug: 'kuhlung',
        image: `${environment.cdnBaseUrl()}/images/zero-results-page/DE-market/kuhlung.webp`,
      },
      {
        id: '3ab2a77b-7f54-46e1-8536-f557426252e1',
        name: 'Kaffeevollautomaten',
        slug: 'kaffeevollautomaten',
        image: `${environment.cdnBaseUrl()}/images/zero-results-page/DE-market/kaffeevollautomaten.webp`,
      },
      {
        id: 'c933836b-3174-4d02-b4f9-51072e621a2d',
        name: 'Besteck',
        slug: 'essbesteck',
        image: `${environment.cdnBaseUrl()}/images/zero-results-page/DE-market/essbesteck.webp`,
      },
      {
        id: '19cc5bcf-670d-4af8-8b4b-8713f59c9541',
        name: 'Alkoholische Getr\u00e4nke',
        slug: 'alkoholische-getraenke',
        image: `${environment.cdnBaseUrl()}/images/zero-results-page/DE-market/alkoholische-getraenke.webp`,
      },
      {
        id: '000339f7-6ab8-4c25-b6bf-2d137e8525b5',
        name: 'Schokolade',
        slug: 'schokolade',
        image: `${environment.cdnBaseUrl()}/images/zero-results-page/DE-market/schokolade.webp`,
      },
      {
        id: '0a98a098-9dc1-4791-8a49-a3665f78ee7e',
        name: 'Kaffee',
        slug: 'kaffee',
        image: `${environment.cdnBaseUrl()}/images/zero-results-page/DE-market/kaffee.webp`,
      },
      {
        id: 'bf266f51-8d87-49e5-b7c9-c48c36ced901',
        name: 'Milch & Kaffeesahne',
        slug: 'milch-und-kaffeesahne',
        image: `${environment.cdnBaseUrl()}/images/zero-results-page/DE-market/milch-und-kaffeesahne.webp`,
      },
    ],
    es: [
      {
        id: 'e45413de-3229-40b6-be52-2f77f97bcdc2',
        name: 'Refrigeraci\u00f3n',
        slug: 'refrigeracion',
        image: `${environment.cdnBaseUrl()}/images/zero-results-page/ES-market/refrigeracion.webp`,
      },
      {
        id: '7904f61c-ab1a-4ca4-971d-3af5a501c150',
        name: 'Muebles de cocina',
        slug: 'muebles-de-acero-inoxidable',
        image: `${environment.cdnBaseUrl()}/images/zero-results-page/ES-market/muebles-de-acero-inoxidable.webp`,
      },
      {
        id: '9721e9e7-78a6-47b6-9168-85538866fd52',
        name: 'Menaje de mesa',
        slug: 'menaje-de-mesa-profesional',
        image: `${environment.cdnBaseUrl()}/images/zero-results-page/ES-market/menaje-de-mesa-profesional.webp`,
      },
      {
        id: 'f33d4f97-3aa3-43d9-9731-67f97e3b7ff5',
        name: 'Recipientes Gastronorm',
        slug: 'recipientes',
        image: `${environment.cdnBaseUrl()}/images/zero-results-page/ES-market/recipientes.webp`,
      },
      {
        id: '11401405-1ee4-4e16-848f-4adc58ed46b8',
        name: 'Armarios expositores refrigerados',
        slug: 'armarios-expositores-refrigerados',
        image: `${environment.cdnBaseUrl()}/images/zero-results-page/ES-market/armarios-expositores-refrigerados.webp`,
      },
      {
        id: 'eb522340-5ffc-498a-899e-b9e014764ca0',
        name: 'Arcones y otros dispositivos de enfriamiento',
        slug: 'cofre-de-enfriamiento',
        image: `${environment.cdnBaseUrl()}/images/zero-results-page/ES-market/cofre-de-enfriamiento.webp`,
      },
      {
        id: '969e67cb-7a18-4d1e-8a68-f97e100ad68c',
        name: 'Frigor\u00edficos expositores',
        slug: 'frigorificos-expositores',
        image: `${environment.cdnBaseUrl()}/images/zero-results-page/ES-market/frigorificos-expositores.webp`,
      },
      {
        id: '82a36ada-0f72-407b-8df9-6f877f6e7a86',
        name: 'Mesas saladette',
        slug: 'mesas-saladette',
        image: `${environment.cdnBaseUrl()}/images/zero-results-page/ES-market/mesas-saladette.webp`,
      },
    ],
    it: [
      {
        id: 'e45413de-3229-40b6-be52-2f77f97bcdc2',
        name: 'Impianti refrigerazione',
        slug: 'impianti-refrigerazione',
        image: `${environment.cdnBaseUrl()}/images/zero-results-page/IT-market/impianti-refrigerazione.webp`,
      },
      {
        id: '9721e9e7-78a6-47b6-9168-85538866fd52',
        name: 'Allestimento della tavola',
        slug: 'allestimento-della-tavola-1',
        image: `${environment.cdnBaseUrl()}/images/zero-results-page/IT-market/allestimento-della-tavola-1.webp`,
      },
      {
        id: 'f33d4f97-3aa3-43d9-9731-67f97e3b7ff5',
        name: 'Contenitori Gastronorm',
        slug: 'contenitori-recipienti-1',
        image: `${environment.cdnBaseUrl()}/images/zero-results-page/IT-market/contenitori-recipienti-1.webp`,
      },
      {
        id: '0ac1b3d6-caef-469d-ae82-379e200b1cf9',
        name: 'Accessori e utensili da bar',
        slug: 'accessori-e-utensili-da-bar',
        image: `${environment.cdnBaseUrl()}/images/zero-results-page/IT-market/accessori-e-utensili-da-bar.webp`,
      },
      {
        id: '11401405-1ee4-4e16-848f-4adc58ed46b8',
        name: 'Frigoriferi con porte a vetro e per bevande',
        slug: 'frigoriferi-con-porte-a-vetro-e-per-bibite',
        image: `${environment.cdnBaseUrl()}/images/zero-results-page/IT-market/frigoriferi-con-porte-a-vetro-e-per-bibite.webp`,
      },
      {
        id: 'e67c205f-9066-4ea1-ae76-da90ae2fc73d',
        name: 'Freezer a pozzo, congelatori a pozzo',
        slug: 'freezer-a-pozzo-congelatori-a-pozzo',
        image: `${environment.cdnBaseUrl()}/images/zero-results-page/IT-market/freezer-a-pozzo-congelatori-a-pozzo.webp`,
      },
      {
        id: '36a06039-2005-4ed8-ae6b-8f013e8d3d5e',
        name: 'Frigoriferi a porta intera',
        slug: 'frigoriferi-ristorazione',
        image: `${environment.cdnBaseUrl()}/images/zero-results-page/IT-market/frigoriferi-ristorazione.webp`,
      },
      {
        id: 'f3d30f75-6f5d-4007-975c-6d96f68e4fc8',
        name: 'Cantinette vino',
        slug: 'frigoriferi-da-vino',
        image: `${environment.cdnBaseUrl()}/images/zero-results-page/IT-market/frigoriferi-da-vino.webp`,
      },
    ],
  };
  outOfScopeSearchQueryList = {
    de: [
      'monin',
      'aperol spritz',
      'fior di latte',
      'monin sirup',
      'monster energy',
      'berliner luft',
      'don pablo',
      'grey goose',
      'absolut vodka',
      'eistee pfirsic',
      'kukki cocktail',
      'rotkäppchen',
      'gerolsteiner',
      'doppio passo',
      'smirnoff',
      'belvedere',
      'havana club',
      'limoncello',
      'san pellegrino',
      'cola zero',
      'desperados',
      'don papa',
      'kinderpunsch',
      'schweppes',
      'three sixty',
      'thomas henry',
      'corona bier',
      'primitivo',
      'apfelschorle',
      'rinderfilet',
      'schweinenacken',
      'tintenfisch',
      'sprühsahne',
      'erbsensuppe',
      'takis chips',
      'rumpsteak',
      'miesmuscheln',
      'kartoffelgratin',
      'rindswurst',
      'bolognese',
      'milka mini',
      'beyond meat',
      'rinderbrust',
      'schokonikolaus',
      'entenbrust',
      'tic tac',
      'nic nacs',
      'san marzano',
      'schweinshaxe',
      'schoko nikolaus',
      'gänsekeule',
      'haribo mini goldbären',
      'laugenbrezel',
      'caputo mehl pizzeria',
      'nackensteak',
      'reibekuchenteig',
      'calamari',
      'cheesecake',
      'halloween süßigkeiten',
      'leberwurst',
      'schweinefilet',
      'schweinefleisch eigenen',
      'spekulatius',
    ],
    es: [
      'ron',
      'gominolas',
      'aceite de oliva virgen extra',
      'aceite oliva virgen extra',
      'chucherias',
      'ron barcelo',
      'solomillo',
      'fanta',
      'beefeater',
      'cruzcampo',
      'redbull',
      'cerveza estrella',
      'jamon iberico',
      'moet',
      'pan bao',
      'aceite virgen extra',
      'estrella damm',
      'garbanzos',
      'halloween',
      'aceite de oliva virgen',
      'tomate triturado',
      'brugal',
      'coca cola zero',
      'aceite oliva virgen',
      'cerveza sin gluten',
      'pan brioche',
      'solan de cabras',
      'carrillera de ternera',
      'coulant',
      'mozzarella',
      'aceite virgen',
      'cerveza alhambra',
      'hojaldre',
      'rama corta verdejo',
      'tinto de verano',
      'ancas de rana',
      'cola cao',
      'entrecot',
      'kimchi',
      'ron barceló',
      'te',
      'jamon serrano',
      'jb',
      'johnnie walker',
      'estrella damm',
      'garbanzos',
      'halloween',
      'aceite de oliva virgen',
      'tomate triturado',
      'brugal',
      'coca cola zero',
      'aceite oliva virgen',
      'cerveza sin gluten',
      'pan brioche',
      'solan de cabras',
      'carrillera de ternera',
      'coulant',
      'mozzarella',
      'aceite virgen',
      'cerveza alhambra',
      'hojaldre',
      'rama corta verdejo',
      'tinto de verano',
      'ancas de rana',
      'cola cao',
      'entrecot',
      'kimchi',
    ],
    it: [
      'moet',
      'olio extravergine',
      'caputo',
      'birra moretti',
      'amaro del capo',
      'mutti',
      'redbull',
      'olio extra vergine',
      'peroni',
      'farina caputo',
      'limoncello',
      'arrosticini',
      'dom perignon',
      'red bull',
      'tanqueray',
      'barilla',
      'tartufo',
      'vecchia romagna',
      'farina petra',
      'acciughe',
      'montenegro',
      'olio evo',
      'goleador',
      'tequila',
      'fanta',
      'funghi porcini',
      'pecorino romano',
      'belvedere',
      'bresaola',
      'campari soda',
      'ferrero',
      'pistacchio',
      'senza glutine',
      'te',
      'aperol spritz',
      'callebaut',
      'chinotto',
      'chupa chups',
      'merendine',
      'monin',
      'olio extravergine di oliva',
      'sciroppo',
      'zucchero bustine',
      'acqua levissima',
      'birre nordiche',
      'cornetti surgelati',
      'dolciumi',
      'merluzzo',
      'mortadella',
      'pasta secca',
      'rio mare',
      'baileys',
      'beyond',
      'cheddar',
      'dolcificante',
      'don perignon',
      'fabbri',
      'fever tree',
      'lemon soda',
      'mascarpone',
      'pasta barilla',
      'ponthier',
      'pringles',
      'rhum',
      'sale in pastiglie',
      'acqua demineralizzata',
      'amica patatine',
      'avocado',
      'belvedere vodka',
      'bottigliette acqua',
      'caramelle gommose',
      'columbus',
    ],
  };

  private readonly _OTHER_BUCKETS_URL: { offerAndStore: string, deliveryService: string }

  get OTHER_BUCKETS_URL(): { offerAndStore: string, deliveryService: string } {
    return this._OTHER_BUCKETS_URL;
  }

  constructor(
    @Optional() @Inject(REQUEST) private webAppBuyerRequest: any,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {
    if (isPlatformBrowser(this.platformId)) {
      this._OTHER_BUCKETS_URL = getOtherBucketsUrl(MarketDetectionUtil.getCountryCode())
    }
  }

  checkOutOfScopeListItems(query: string): boolean {
    const userCountry = getCountryDomainCode(this.webAppBuyerRequest);
    if (Object.keys(this.outOfScopeSearchQueryList).includes(userCountry.toLowerCase())) {
      const userCountryOutOfScopeSearchQueries = this.outOfScopeSearchQueryList[userCountry].map((item: string) =>
        item.toLowerCase()
      );
      this.hasOutOfScopeTerms = userCountryOutOfScopeSearchQueries.some((term: string) =>
        term.includes(query.toLowerCase().trim())
      );
    }
    return this.hasOutOfScopeTerms;
  }

  redirectToOtherBucket(bucket: OtherBuckets, searchQuery: string): void {
    if (this.OTHER_BUCKETS_URL) {
      window.open(`${this.OTHER_BUCKETS_URL[bucket]}${searchQuery}`, '_blank');
    }
  }

  populateCountryCategoriesCards(): OutOfScopeCategory {
    const userCountry = getCountryDomainCode(this.webAppBuyerRequest);
    if (Object.keys(this.outOfScopeCategoryList).includes(userCountry.toLowerCase())) {
      this.userCountryOutOfScopeCategoryList = this.outOfScopeCategoryList[userCountry];
    }
    return this.userCountryOutOfScopeCategoryList;
  }
}
